import React from 'react';
import { Box } from '@mui/material';
import Image from 'next/image';
type props={
	imageType: keyof typeof images
}
const images={
    bar:"/barloader.gif",
    circle:"/circleloader.gif"
}
const Loader = ({imageType="bar"}:props) => {
	return (
		<Box
			style={{
				position: 'fixed',
				top: '0px',
				left: '0px',
				height: '100vh',
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundColor: 'rgba(0, 0, 0, 0.09)',
				zIndex: 200000,
			}}
		>
			<Image  alt="loader img" src={images[imageType]} width="200" height="200" unoptimized/>
		</Box>
	);
};

export default Loader;
